/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Vue from 'vue'
import { encodeScriptTag } from '@/helpers/utils'

export default {
  resetState (state) {
    state.content = null
    state.meta.title = ''
    state.meta.abstract = ''
    state.meta.decription = ''
    state.meta.keywords = ''
    state.meta.openGraph = {}
  },
  setPage (state, data) {
    state.content = encodeScriptTag(data.content)
    state.meta = data.meta || {}
    return data
  },
  setContent (state, IDAndcontent) {
    let content = {
      content: encodeScriptTag(IDAndcontent.data.content),
      title: IDAndcontent.data.title
    }
    Vue.set(state.contents, IDAndcontent.contentID, content)
  },
  cleanContents (state) {
    state.contents = {}
  },
  currentComponent (state, componentType) {
    state.currentComponent = componentType
  },
  setUrlVideoModal (state, url) {
    state.videoModalUrl = url
  },
  setHeaderBanner (state, headerBanner) {
    state.contents['header-banner'] = headerBanner
  },
  setSsrIDS (state, id) {
    state.ssrIDS.push(id)
  },
  blogParentCat (state, blogParentCat) {
    state.blogParentCat = blogParentCat
  },
  blogCurrCat (state, blogCurrCat) {
    state.blogCurrCat = blogCurrCat
  },
  blogCurrPost (state, blogPost) {
    state.blogPost = blogPost
  }
}
